module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/design_type_of_simple-633e5c6549f760feadb5c71cb88e60b2.png";